/* TPL Collection Brief — lazy video + pause control.
   Converted 2026-05-05 from eager autoplay to IntersectionObserver-driven
   lazy load. Each `<video>` ships with `data-lazy-src` instead of `src` and
   `preload="none"`, so the browser fetches nothing until the section is
   within ~400px of the viewport. Saves ~30 MB on mobile first-visit when
   the user bounces above the fold. Same pattern is reused below for
   `.tpl-le-home__video` (single-video sibling section). */
(function () {
  /* Idempotency guard — script may be included by both tpl-collection-brief
     and tpl-le-home-claims sections on the same page. Browsers fetch the
     asset once but execute the IIFE per <script> tag, so guard manually. */
  if (window.__tplLazyVideoInit) return;
  window.__tplLazyVideoInit = true;

  var SECTIONS = document.querySelectorAll('[data-tpl-brief], [data-tpl-le-home]');
  if (!SECTIONS.length) return;

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function attachSrc(video) {
    if (video.dataset.lazyAttached === '1') return;
    var url = video.dataset.lazySrc;
    if (!url) return;
    /* iOS Safari: muted/playsinline must be on the element BEFORE load/play. */
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.preload = 'auto';
    video.src = url;
    video.dataset.lazyAttached = '1';
    try { video.load(); } catch (e) {}
  }

  function safePlay(video) {
    if (REDUCED) return;
    if (video.dataset.userPaused === '1') return;
    var p = video.play && video.play();
    if (p && p.then) {
      p.catch(function () {
        /* Autoplay blocked. Resume on first user gesture. */
        var resume = function () {
          video.play().catch(function () {});
          ['touchstart', 'click', 'keydown', 'scroll'].forEach(function (ev) {
            document.removeEventListener(ev, resume);
          });
        };
        ['touchstart', 'click', 'keydown', 'scroll'].forEach(function (ev) {
          document.addEventListener(ev, resume, { passive: true, once: true });
        });
      });
    }
  }

  /* Pre-arm at 400px so video has a moment to buffer before reveal. */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var video = entry.target;
      if (entry.isIntersecting) {
        attachSrc(video);
        safePlay(video);
      } else {
        if (video.dataset.lazyAttached === '1' && !video.paused) {
          try { video.pause(); } catch (e) {}
        }
      }
    });
  }, { rootMargin: '400px 0px', threshold: 0 }) : null;

  SECTIONS.forEach(function (section) {
    var videos = section.querySelectorAll('video[data-lazy-src]');
    if (!videos.length) return;

    videos.forEach(function (v) {
      if (io) {
        io.observe(v);
      } else {
        /* No IO support — eager fallback. Same behaviour as before this fix. */
        attachSrc(v);
        safePlay(v);
      }
    });

    /* Pause button — scoped to the nearest video in its own media wrapper.
       Each brief renders 4 <video> tags (mobile/desktop × normal/flipped
       layouts) but CSS shows only one at a time; videos[0] may be hidden and
       unattached, so a global "pause videos[0]" never triggered (broken on
       LFE with the flipped layout). Per-button scoping fixes that — and also
       lets the button kick the lazy attach if the user reaches it before IO
       fires (e.g. fast-scroll past the rootMargin). */
    var btns = section.querySelectorAll('[data-brief-pause]');
    if (!btns.length) return;
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var media = btn.closest('.tpl-brief__media-inner, .tpl-brief__media-mobile') || btn.parentElement;
        var v = media ? media.querySelector('video[data-lazy-src]') : btn.previousElementSibling;
        if (!v || v.tagName !== 'VIDEO') return;
        if (v.dataset.lazyAttached !== '1') {
          attachSrc(v); /* user reached it before IO — attach now */
        }
        var paused = v.paused;
        if (paused) {
          v.dataset.userPaused = '0';
          var p = v.play();
          if (p && p.then) p.catch(function () {});
          btn.textContent = '❚❚';
          btn.setAttribute('aria-label', 'Pause video');
        } else {
          v.dataset.userPaused = '1';
          v.pause();
          btn.textContent = '▶';
          btn.setAttribute('aria-label', 'Play video');
        }
      });
    });
  });
})();
